import { apiClient } from '@/services/ApiClient.js'

export class RewardService {
  static getRewards() {
    return apiClient
      .get('rewards')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getReward(id) {
    return apiClient
      .get('rewards/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static createReward(reward) {
    return apiClient
      .post('rewards', reward)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static updateReward(id, reward) {
    return apiClient
      .patch('rewards/' + id, reward)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static deleteReward(id) {
    return apiClient
      .delete('rewards/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static uploadImage(id, form) {
    let formData = new FormData()
    formData.append('file', form.file)

    return apiClient
      .postForm('rewards/' + id + '/image', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
